<template>
  <!--  <div class="e4s-flex-row e4s-gap&#45;&#45;standard e4s-flex-wrap">-->
  <!--    <div class="e4s-flex-row e4s-gap&#45;&#45;small" v-for="athlete in athletes" :key="athlete.athleteId">-->
  <!--      <div v-text="athlete.position"></div>-->
  <!--      <div v-text="athlete.bibNo"></div>-->
  <!--      <div v-text="athlete.athlete"></div>-->
  <!--      <div v-text="cleanUpScoreValueForDisplay(athlete.scoreValue)"></div>-->
  <!--    </div>-->
  <!--  </div>-->
  <!--    <table>-->
  <!--      <tr>-->
  <!--        <th>Position</th>-->
  <!--        <th>Bib No</th>-->
  <!--        <th>Athlete</th>-->
  <!--        <th>Score</th>-->
  <!--      </tr>-->
  <!--      <tr v-for="athlete in top3Athletes" :key="athlete.athleteId" class="e4s-subheader&#45;&#45;300">-->
  <!--        <td>{{ athlete.position }}</td>-->
  <!--        <td>{{ athlete.bibNo }}</td>-->
  <!--        <td>{{ athlete.athlete }}</td>-->
  <!--        <td>{{ cleanUpScoreValueForDisplay(athlete.scoreValue) }}</td>-->
  <!--      </tr>-->
  <!--    </table>-->
  <div class="e4s-flex-row e4s-gap--standard e4s-flex-wrap">
    <div
      class="e4s-flex-row e4s-gap--standard e4s-subheader--general e4s-subheader--300"
      v-for="athlete in top3Athletes"
      :key="athlete.athleteId"
    >
      <div v-text="athlete.position"></div>
      <!--      <div v-text="athlete.bibNo"></div>-->
      <div v-text="athlete.athlete"></div>
      <div v-text="cleanUpScoreValueForDisplay(athlete.scoreValue)"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SocketResultSummaryField } from '@/components/results/socket/live-feed/live-feed-models'
import { computed, type PropType } from 'vue'
import { cleanUpScoreValueForDisplay } from '@/components/results/results-service'

const props = defineProps({
  athletes: {
    type: Array as PropType<SocketResultSummaryField[]>,
    required: true
  }
})

// get computed() of athletes sorted by position then take the first 3 in array
const top3Athletes = computed<SocketResultSummaryField[]>(() => {
  //  filter out position 0
  return props.athletes
    .filter((athlete) => athlete.position > 0)
    .sort((a, b) => a.position - b.position)
    .slice(0, 3)
})
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

th {
  background-color: var(--slate-200);

  font-weight: 500;
  text-align: left;
}

th,
td {
  padding: var(--e4s-gap--small);
  border-bottom: 1px solid var(--slate-100);
}

tr:nth-child(even) {
  background-color: var(--slate-50);
}
</style>
